import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import LoginPage from "./LoginPage";
import ChangePwd from "./ChangePwd";
import Header from "./Header/Header";
import ITDashboard from "./Sidebar/ITDashboard";
import TvLogin from "./Sidebar/TvLogin";
import commonFunctions from "./Sidebar/Common";
const root = ReactDOM.createRoot(document.getElementById("root"));
Object.assign(window, commonFunctions);
function renderTvDashboard(authDetail) {
  root.render(
    <React.StrictMode>
      <ITDashboard tvAuthDetail={authDetail} />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="colored"
      />
    </React.StrictMode>,
  );
}
function tick() {
  // TV mode: show OTP login page when ?tv is in URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("tv")) {
    root.render(
      <React.StrictMode>
        <TvLogin onAuthenticated={renderTvDashboard} />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="colored"
        />
      </React.StrictMode>,
    );
    return;
  }
  const userName = sessionStorage.getItem("userName");
  const isPwd = sessionStorage.getItem("isPwd");
  var element = "";
  if (!userName) {
    element = <LoginPage />;
  } else if (isPwd < 1) {
    // console.log(isPwd);
    element = <Header />;
  } else {
    element = <ChangePwd />;
  }
  root.render(
    <React.StrictMode>
      {element}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="colored"
      />
    </React.StrictMode>,
  );
}
tick();
reportWebVitals();
